if (!customElements.get('nextbottle-final-buy')) {
  customElements.define('nextbottle-final-buy', class extends HTMLElement {
    connectedCallback() {
      this.box = document.querySelector('nextbottle-buybox');
      if (!this.box) return;
      this.button = this.querySelector('button');
      this.selection = this.querySelector('[data-nb-final-selection]');
      this.price = this.querySelector('[data-nb-final-price]');
      this.images = document.createElement('div');
      this.images.setAttribute('data-nb-final-images', '');
      this.images.style.cssText = 'display:flex;justify-content:center;gap:12px;margin:20px auto;max-width:520px';
      this.selection.after(this.images);
      this.update = () => {
        const state = this.box.querySelector('[data-nb-offer-state]');
        const submit = state?.querySelector('[type="submit"]');
        const pending = this.box.loading || this.box.adding || !!this.box.querySelector('[aria-busy="true"]');
        const failed = this.box.failed;
        this.button.disabled = pending || failed || !submit || submit.disabled;
        this.button.textContent = pending ? 'Wird geprüft …' : failed ? 'Auswahl bitte erneut prüfen' : submit?.textContent.trim() || 'Nicht verfügbar';
        this.price.textContent = pending || failed ? '' : state?.querySelector('[data-nb-price] strong')?.textContent.trim() || '';
        const count = this.box.querySelector('[data-nb-offer][aria-current="true"]')?.dataset.nbCount || '1';
        const colors = Array.from(state?.querySelectorAll('[data-nb-option]:checked') || [], input => input.dataset.nbColorName);
        this.selection.textContent = `${count} × Thermora · ${colors.join(' / ')}`;
        const options = Array.from(state?.querySelectorAll('[data-nb-option]:checked') || []);
        const signature = JSON.stringify([pending, failed, count, options.map(input => [input.value, input.closest('label')?.querySelector('img')?.getAttribute('src')])]);
        if (signature !== this.imageSignature) {
          this.imageSignature = signature;
          this.images.replaceChildren();
          if (!pending && !failed) options.forEach((input, index) => {
            const source = input.closest('label')?.querySelector('img') || this.box.querySelector('nextbottle-bundle-media')?.mapping?.get(input.value)?.content.querySelector('img');
            if (!source) return;
            const figure = document.createElement('figure');
            figure.style.cssText = 'margin:0;flex:1;min-width:0;max-width:160px';
            const image = source.cloneNode(true);
            image.alt = `${index + 1}. Farbe: ${input.dataset.nbColorName || ''}`;
            image.style.cssText = 'display:block;width:100%;height:auto;aspect-ratio:1;object-fit:cover;border-radius:12px';
            image.sizes = '(max-width: 600px) 28vw, 160px';
            image.loading = 'lazy';
            image.addEventListener('error', () => { image.hidden = true; image.style.display = 'none'; });
            const caption = document.createElement('figcaption');
            caption.style.cssText = 'font-size:14px;line-height:1.35;margin-top:8px;overflow-wrap:anywhere';
            caption.textContent = `${index + 1}. Farbe: ${input.dataset.nbColorName || ''}`;
            figure.append(image, caption);
            this.images.append(figure);
          });
        }
      };
      this.onSubmit = () => {
        const form = this.box.querySelector('form');
        const submit = form?.querySelector('[type="submit"]');
        const id = form?.querySelector('[name="id"]');
        if (this.box.loading || this.box.failed || this.box.adding || this.box.querySelector('[aria-busy="true"]') || !id?.value || id.disabled || !submit || submit.disabled) return;
        form.requestSubmit(submit);
      };
      this.button.addEventListener('click', this.onSubmit);
      this.box.addEventListener('change', this.update);
      this.observer = new MutationObserver(this.update);
      this.observer.observe(this.box, {subtree:true, childList:true, characterData:true, attributes:true, attributeFilter:['disabled','aria-busy','aria-current','checked']});
      this.update();
      this.hidden = false;
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.button?.removeEventListener('click', this.onSubmit);
      this.box?.removeEventListener('change', this.update);
      this.images?.remove();
    }
  });
}
